import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useFormContext } from 'react-hook-form';

import { CheckoutContext } from '@/contexts/CheckoutContext';
import TextField from '@/components/common/TextField';
import couponIcon from '../../../../public/assets/coupon.svg';

export default function CouponFormNew() {
  const [searchParams] = useSearchParams();
  const couponParam = searchParams.get('coupon') || undefined;

  const form = useFormContext();
  const { couponData, validateCoupon, applyCouponValue, setApplyCouponValue } =
    useContext(CheckoutContext);

  const [coupon, setCoupon] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    form.clearErrors('coupon');
    setCoupon(e.target.value);
  };

  const handleApplyCoupon = () => {
    if (coupon && !applyCouponValue) {
      validate(coupon);
    }
  };

  const handleRemoveCoupon = () => {
    setCoupon('');
    form.setValue('coupon', undefined);
    setApplyCouponValue(0);
  };

  async function validate(coupon: string) {
    try {
      await validateCoupon(coupon);
      form.clearErrors('coupon');
    } catch (error: any) {
      form.setError('coupon', {
        message: error?.response?.data.detail || 'Cupom inválido ou vencido.'
      });
      setApplyCouponValue(0);
    }
  }

  useEffect(() => {
    if (couponData?.code) {
      form.setValue('coupon', couponData?.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponData]);

  useEffect(() => {
    if (couponParam) {
      validate(couponParam);
      form.setValue('coupon', couponParam);
      setCoupon(couponParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponParam]);

  return (
    <div className="flex w-full flex-col items-start gap-3">
      <TextField
        name="coupon"
        size="sm"
        label=""
        placeholder="Código de desconto"
        startIcon={
          <div className={`absolute inset-y-0 pl-3 flex items-center pointer-events-none`}>
            <img src={couponIcon} alt="Coupon Icon" />
          </div>
        }
        hideErrorIcon
        value={coupon}
        disabled={!!applyCouponValue}
        onChange={handleChange}
        normalize
        actions={
          !!couponData && !!applyCouponValue ? (
            <CouponButton
              text="Remover Cupom"
              onClick={handleRemoveCoupon}
              className="text-red-500 hover:text-red-600"
            />
          ) : (
            <CouponButton
              text="Aplicar Cupom"
              onClick={handleApplyCoupon}
              className="text-green-500 hover:text-green-600"
            />
          )
        }
      />
    </div>
  );
}

function CouponButton({ text, onClick, className }: any) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`absolute top-[0.5rem] right-2 font-semibold transition-colors text-[14px] ${className}`}
    >
      {text}
    </button>
  );
}
